import { FETCH_EMPLOYEES_REQUEST, FETCH_EMPLOYEES_SUCCESS, FETCH_EMPLOYEES_FAILED } from "../actions/types"



const initalState = {
    loading : false,
    employees : [],
    error : null
}


const employeeReducer = (state = initalState , action) => {
    switch(action.type){
        case FETCH_EMPLOYEES_REQUEST : {
            return {...state ,
            loading : true
            }
        }
        case FETCH_EMPLOYEES_SUCCESS : {
            return {
                ...state,
                loading :false,
                employees : action.payload
            }
        }   
        case FETCH_EMPLOYEES_FAILED : {
            return {
                ...state,
                loading : true,
                error : action.payload
            }
        }
        default : {
            return {
                ...state
            }
        }
    }

}


export default employeeReducer